// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".master-check[data-v-6068ad77]{margin-left:.34722rem}.box-spacing[data-v-6068ad77]{margin:0 .05556rem}", ""]);
// Exports
module.exports = exports;
